import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { TranslateLanguageService } from '../../../abraj-shared/src/lib/services/translate-language.service';
import { ModalComponent } from '../../../abraj-shared/src/public-api';
import { DeviceDetectionService } from '../../../abraj-shared/src/lib/services/device-detection.service';
import { UnsupportedDeviceComponent } from '../../../abraj-shared/src/lib/components/unsupported-device/unsupported-device.component';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, ModalComponent, UnsupportedDeviceComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent {
   public readonly languageService = inject(TranslateLanguageService);
   public readonly deviceDetection = inject(DeviceDetectionService);
}
